var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    't-label',
    ("t-label_color-" + _vm.color),
    ("t-label_size-" + _vm.size)
  ]},[_vm._t("default"),_c('CloseButton',{class:[
      't-label__close-button',
      { enabled: _vm.showCloseButton }
    ],on:{"click":function($event){return _vm.$emit('close')}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }